export default "__VITE_ASSET__D1O_J4M7__"